import { gql } from '@apollo/client';

export const regeneratePolicyDocuments = gql`
  mutation regeneratePolicyDocuments($id: String!) {
    production {
      regeneratePolicyDocuments(id: $id) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const modifyGenericDetails = gql`
  mutation modifyGenericDetails($input: ModifyGenericDetailsInput!) {
    production {
      modifyGenericDetails(input: $input)
    }
  }
`;

export const initializePolicyCorrection = gql`
  mutation InitializePolicyCorrection($policyId: String!) {
    production {
      initializePolicyCorrection(policyId: $policyId)
    }
  }
`;

export const downloadGroupMedicalCertificates = gql`
  mutation downloadGroupMedicalCertificatesDetails($id: String!) {
    production {
      downloadGroupMedicalCertificatesDetails(id: $id) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const downloadFleetCertificatesDetails = gql`
  mutation downloadFleetCertificatesDetails($id: String!) {
    production {
      downloadGroupFleetCertificatesDetails(id: $id) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const downloadGroupFleetMarineCertificatesDetails = gql`
  mutation downloadGroupFleetMarineCertificatesDetails($id: String!) {
    production {
      downloadGroupFleetMarineCertificatesDetails(id: $id) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const addPolicyAdditionalDocMutation = gql`
  mutation addPolicyAdditionalDocument(
    $policyID: String!
    $documentName: String!
    $document: Upload!
  ) {
    production {
      addPolicyAdditionalDocument(
        policyID: $policyID
        documentName: $documentName
        document: $document
      )
    }
  }
`;

export const uploadFleetList = gql`
  mutation uploadFleetList(
    $document: Upload!
    $documentName: String!
    $policyID: String!
  ) {
    production {
      uploadFleetList(
        document: $document
        documentName: $documentName
        policyID: $policyID
      ) {
        column
        description
        row
        type
      }
    }
  }
`;

export const uploadMarineFleetList = gql`
  mutation uploadMarineFleetList(
    $document: Upload!
    $documentName: String!
    $policyID: String!
  ) {
    production {
      uploadMarineFleetList(
        document: $document
        documentName: $documentName
        policyID: $policyID
      ) {
        column
        description
        row
        type
      }
    }
  }
`;

export const addCertificate = gql`
  mutation addCertificate($document: Upload!, $policyID: String!) {
    production {
      addCertificate(document: $document, policyID: $policyID)
    }
  }
`;

export const addMarineCertificate = gql`
  mutation addMarineCertificate($document: Upload!, $policyID: String!) {
    production {
      addMarineCertificate(document: $document, policyID: $policyID)
    }
  }
`;
